import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'base-banner-message',
  templateUrl: './base-banner-message.component.html',
  styleUrls: ['./base-banner-message.component.scss'],
})
export class BaseBannerMessageComponent implements OnInit {
  @Input() text: string | SafeHtml;
  @Input() alertType: 'warn' | 'alert' | 'default' = 'default';
  @Input() textButton: string;
  @Input() showButton = false;
  @Input() noMargin = false;
  @Input() dismissible = false;
  @Input() callButton: () => any;
  @Output() onDismiss = new EventEmitter<void>();

  colorButton: ThemePalette = 'primary';

  private alertColors: { [key: string]: ThemePalette } = {
    alert: 'warn',
    warn: 'warn',
    default: 'primary',
  };

  constructor() {}

  ngOnInit(): void {
    this.setColorButton();
  }

  private setColorButton(): void {
    this.colorButton = this.alertColors[this.alertType] || this.alertColors.default;
  }

  getBorderClasses(): string {
    let classVar = 'card border-l-4 p-4 mt-4';
    if (this.noMargin) {
      classVar = 'border-l-4 p-4';
    }
    switch (this.alertType) {
      case 'alert':
        return `${classVar} border-red`;
      case 'warn':
        return `${classVar} border-yellow`;
      default:
        return `${classVar} border-blue`;
    }
  }

  dismiss(): void {
    this.onDismiss.emit();
  }
}
